import React from "react";
import { TextField, TextFieldProps, useTheme } from "@mui/material";

interface CustomTextFieldProps extends Omit<TextFieldProps, "label"> {
  label?: string;
  height?: string | number;
  inputPadding?: string;
  labelTransform?: string;
  labelTransformDefault?: string;
  borderRadius?: string;
  labelFontSize?: string;
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  label,
  height = "56px",
  inputPadding = "0 16px",
  labelTransform = "translate(16px, -8px) scale(1)",
  labelTransformDefault,
  borderRadius = "32px",
  labelFontSize = "15px",
  sx,
  ...props
}) => {
  const theme: any = useTheme();

  // Calcular transform padrão baseado na altura do input
  const getDefaultTransform = () => {
    if (labelTransformDefault) {
      return labelTransformDefault;
    }
    const heightValue = typeof height === 'string' 
      ? parseFloat(height.replace('px', '')) 
      : typeof height === 'number' 
        ? height 
        : 56;
    // Centralizar verticalmente: altura do input / 2 - metade da altura da linha do texto
    // Usar line-height padrão do Material-UI que é aproximadamente 1.5x o font-size
    const fontSizeValue = parseFloat(labelFontSize.replace('px', ''));
    const lineHeight = fontSizeValue * 1.5; // Material-UI usa line-height de 1.5 por padrão
    const translateY = (heightValue / 2) - (lineHeight / 2);
    return `translate(16px, ${translateY}px) scale(1)`;
  };

  return (
    <TextField
      {...props}
      label={label}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: borderRadius,
          backgroundColor: theme.palette.grey[900],
          height: height,
          "& fieldset": {
            borderColor: theme.palette.grey[700],
          },
          "&:hover fieldset": {
            borderColor: theme.palette.grey[600],
          },
          "&.Mui-focused fieldset": {
            borderColor: theme.palette.grey[500],
          },
        },
        "& .MuiInputBase-input": {
          color: theme.palette.grey[0],
          fontSize: "15px",
          ...(props.multiline ? {} : { height: height }),
          padding: inputPadding,
          ...(props.inputProps?.style),
        },
        "& .MuiInputLabel-root": {
          color: "#FFFFFF",
          fontSize: labelFontSize,
          lineHeight: 1.5,
          transform: getDefaultTransform(),
          "&.Mui-focused": {
            color: theme.palette.grey[500],
          },
          "&.MuiInputLabel-shrink": {
            color: "#FFFFFF",
            fontSize: "10px",
            backgroundColor: "#333333",
            padding: "0 8px",
            transform: labelTransform,
          },
        },
        ...sx,
      }}
    />
  );
};

export default CustomTextField;
